module.exports = __webpack_public_path__ + "img/registration_back.767374da.svg";